import { renderError, Fetch, displayError } from './helpers';

export const axleLoadCalculator = () => {
  const isAxleLoadCalculator = document.querySelector('form[data-end-point="/api/calculations/calculate_axle_load/"]');
  if (!isAxleLoadCalculator) return;

  const calculatorForm = isAxleLoadCalculator;
  const resultContainer = calculatorForm.closest('.calculator').querySelector('.calculator__form-result-desc');
  const imageContainer = calculatorForm.closest('.calculator').querySelector('.calculator__form-result-img');
  const ctaContainer = calculatorForm.closest('.calculator').querySelector('.calculator__cta');
  const resultFormContainer = calculatorForm.closest('.calculator').querySelector('.calculator__rezult-form');

  if (!calculatorForm) {
    return;
  }

  // Получаем элементы шагов
  const stepsButtons = calculatorForm.closest('.calculator').querySelectorAll('.calculator__steps-btn');
  const stepsContent = {
    one: calculatorForm.querySelector('.calculator__steps-one'),
    two: calculatorForm.querySelector('.calculator__steps-two'),
    three: calculatorForm.querySelector('.calculator__steps-three')
  };

  // Получаем кнопки навигации
  const nextButtons = calculatorForm.querySelectorAll('.calculator__btn-next');
  const backButtons = calculatorForm.querySelectorAll('.calculator__btn-back');
  const errorMessages = calculatorForm.querySelectorAll('.calculator__btn-next-error-txt');

  let currentStep = 1;

  // Инициализация калькулятора
  initCalculator();

  function initCalculator() {
    showStep(1);
    addEventListeners();
    addInputValidation();
    setupInitialFieldVisibility();
    // Инициализируем картинки для шагов 2 и 3
    updateStepImage(2);
    updateStepImage(3);
  }

  // Функция для получения текущих параметров осей
  function getAxleParameters() {
    const tractorAxles = calculatorForm.querySelector('input[name="tractor_axles_count"]:checked')?.value || '2';
    const trailerAxles = calculatorForm.querySelector('input[name="trailer_axles_count"]:checked')?.value || '1';
    return { tractorAxles, trailerAxles };
  }

  // Функция для получения базового пути к изображениям
  function getImagesBasePath() {
    return calculatorForm.getAttribute('data-images-path') || '/static/images/axleLoadCalculator/';
  }

  // Функция для обновления картинки на шаге
  function updateStepImage(stepNumber) {
    const { tractorAxles, trailerAxles } = getAxleParameters();
    const basePath = getImagesBasePath();
    
    let stepElement, imagePrefix;
    
    switch (stepNumber) {
      case 2:
        stepElement = stepsContent.two;
        imagePrefix = 'step2-Axle';
        break;
      case 3:
        stepElement = stepsContent.three;
        imagePrefix = 'step3-Weight';
        break;
      default:
        return;
    }
    
    if (!stepElement) return;
    
    const imageElement = stepElement.querySelector('.calculator__steps-content-img-item');
    if (imageElement) {
      const imagePath = `${basePath}${imagePrefix}-${tractorAxles}+${trailerAxles}.svg`;
      imageElement.src = imagePath;
    }
  }

  // Функция для обновления картинки в результатах
  function updateResultImage() {
    const { tractorAxles, trailerAxles } = getAxleParameters();
    const basePath = getImagesBasePath();
    const resultImageElement = document.getElementById('result-image');
    
    if (resultImageElement) {
      const imagePath = `${basePath}step2-Axle-${tractorAxles}+${trailerAxles}.svg`;
      resultImageElement.src = imagePath;
    }
  }

  function setupInitialFieldVisibility() {
    // Инициализируем видимость полей для осей тягача и полуприцепа
    const tractorAxlesDefault = calculatorForm.querySelector('input[name="tractor_axles_count"]:checked');
    if (tractorAxlesDefault) {
      handleTractorAxlesChange({ target: tractorAxlesDefault });
    }

    const trailerAxlesDefault = calculatorForm.querySelector('input[name="trailer_axles_count"]:checked');
    if (trailerAxlesDefault) {
      handleTrailerAxlesChange({ target: trailerAxlesDefault });
    }
  }

  function addEventListeners() {
    // Обработчики для кнопок "Далее" с использованием event delegation
    nextButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        
        if (currentStep === 3) { // Последний шаг - кнопка "Рассчитать"
          submitCalculation();
        } else {
          handleNextStep();
        }
      });
    });

    // Обработчики для кнопок "Назад"
    backButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        handlePrevStep();
      });
    });

    // Обработчики для радиокнопок осей тягача
    const tractorAxlesRadios = calculatorForm.querySelectorAll('input[name="tractor_axles_count"]');
    tractorAxlesRadios.forEach(radio => {
      radio.addEventListener('change', handleTractorAxlesChange);
    });

    // Обработчики для радиокнопок осей полуприцепа
    const trailerAxlesRadios = calculatorForm.querySelectorAll('input[name="trailer_axles_count"]');
    trailerAxlesRadios.forEach(radio => {
      radio.addEventListener('change', handleTrailerAxlesChange);
    });
  }

  function addInputValidation() {
    // Получаем все числовые инпуты калькулятора
    const calculatorInputs = calculatorForm.querySelectorAll('input[inputmode="decimal"]');

    // Добавляем валидацию ко всем числовым инпутам
    calculatorInputs.forEach(input => {
      input.addEventListener('input', function (event) {
        // Разрешаем только цифры, точку и запятую
        event.target.value = event.target.value.replace(/[^0-9.,]/g, '');
      });
    });
  }

  function handleTractorAxlesChange(event) {
    const axlesCount = parseInt(event.target.value);
    const thirdAxleInput = calculatorForm.querySelector('#second_group_load_2');
    const thirdAxleGroup = thirdAxleInput?.closest('.calculator__input-group');
    
    if (axlesCount === 2) {
      if (thirdAxleGroup) thirdAxleGroup.classList.add('calculator__input-group--hidden');
      if (thirdAxleInput) thirdAxleInput.removeAttribute('required');
    } else {
      if (thirdAxleGroup) thirdAxleGroup.classList.remove('calculator__input-group--hidden');
      if (thirdAxleInput) thirdAxleInput.setAttribute('required', 'required');
    }
    
    // Обновляем картинки на шагах 2 и 3
    updateStepImage(2);
    updateStepImage(3);
  }

  function handleTrailerAxlesChange(event) {
    const axlesCount = parseInt(event.target.value);
    const secondAxleInput = calculatorForm.querySelector('#third_group_load_2');
    const thirdAxleInput = calculatorForm.querySelector('#third_group_load_3');
    const secondAxleGroup = secondAxleInput?.closest('.calculator__input-group');
    const thirdAxleGroup = thirdAxleInput?.closest('.calculator__input-group');
    
    if (axlesCount === 1) {
      if (secondAxleGroup) secondAxleGroup.classList.add('calculator__input-group--hidden');
      if (thirdAxleGroup) thirdAxleGroup.classList.add('calculator__input-group--hidden');
      if (secondAxleInput) secondAxleInput.removeAttribute('required');
      if (thirdAxleInput) thirdAxleInput.removeAttribute('required');
    } else if (axlesCount === 2) {
      if (secondAxleGroup) secondAxleGroup.classList.remove('calculator__input-group--hidden');
      if (thirdAxleGroup) thirdAxleGroup.classList.add('calculator__input-group--hidden');
      if (secondAxleInput) secondAxleInput.setAttribute('required', 'required');
      if (thirdAxleInput) thirdAxleInput.removeAttribute('required');
    } else {
      if (secondAxleGroup) secondAxleGroup.classList.remove('calculator__input-group--hidden');
      if (thirdAxleGroup) thirdAxleGroup.classList.remove('calculator__input-group--hidden');
      if (secondAxleInput) secondAxleInput.setAttribute('required', 'required');
      if (thirdAxleInput) thirdAxleInput.setAttribute('required', 'required');
    }
    
    // Обновляем картинки на шагах 2 и 3
    updateStepImage(2);
    updateStepImage(3);
  }

  function showStep(stepNumber) {
    // Скрываем все шаги
    Object.values(stepsContent).forEach(step => {
      if (step) {
        step.classList.remove('calculator__steps-one--active', 'calculator__steps-two--active', 'calculator__steps-three--active');
      }
    });

    // Убираем активные классы с кнопок шагов
    stepsButtons.forEach(btn => {
      btn.classList.remove('calculator__steps-btn--active');
    });

    // Показываем нужный шаг
    switch (stepNumber) {
      case 1:
        if (stepsContent.one) stepsContent.one.classList.add('calculator__steps-one--active');
        if (stepsButtons[0]) stepsButtons[0].classList.add('calculator__steps-btn--active');
        break;
      case 2:
        if (stepsContent.two) stepsContent.two.classList.add('calculator__steps-two--active');
        if (stepsButtons[1]) stepsButtons[1].classList.add('calculator__steps-btn--active');
        break;
      case 3:
        if (stepsContent.three) stepsContent.three.classList.add('calculator__steps-three--active');
        if (stepsButtons[2]) stepsButtons[2].classList.add('calculator__steps-btn--active');
        break;
    }

    currentStep = stepNumber;
  }

  function validateCurrentStep() {
    let currentStepElement;
    
    switch (currentStep) {
      case 1:
        currentStepElement = stepsContent.one;
        break;
      case 2:
        currentStepElement = stepsContent.two;
        break;
      case 3:
        currentStepElement = stepsContent.three;
        break;
      default:
        return false;
    }

    if (!currentStepElement) {
      return false;
    }

    const requiredInputs = currentStepElement.querySelectorAll('input[required]');
    
    let isValid = true;
    let invalidFields = [];

    requiredInputs.forEach(input => {
      // Проверяем только видимые поля
      const inputGroup = input.closest('.calculator__input-group');
      const isVisible = !inputGroup || !inputGroup.classList.contains('calculator__input-group--hidden');
      
      if (isVisible && !input.value.trim()) {
        isValid = false;
        invalidFields.push(input.name || input.id);
      }
    });

    return isValid;
  }

  function showStepError(stepIndex) {
    if (errorMessages[stepIndex]) {
      errorMessages[stepIndex].classList.add('calculator__btn-next-error-txt--visible');
      setTimeout(() => {
        errorMessages[stepIndex].classList.remove('calculator__btn-next-error-txt--visible');
      }, 3000);
    }
  }

  function handleNextStep() {
    if (!validateCurrentStep()) {
      showStepError(currentStep - 1);
      return;
    }

    if (currentStep < 3) {
      showStep(currentStep + 1);
    }
  }

  function handlePrevStep() {
    if (currentStep > 1) {
      showStep(currentStep - 1);
    }
  }

  // Функция для нормализации числового ввода (заменяет запятую на точку)
  function normalizeDecimalInput(value) {
    if (typeof value === 'string') {
      return value.replace(',', '.');
    }
    return value;
  }

  function collectFormData() {
    const formData = new FormData(calculatorForm);

    // Собираем массивы нагрузок
    const secondGroupLoad = [];
    const thirdGroupLoad = [];
    const cargoessMass = [];

    // Собираем second_group_load
    const secondGroupInputs = calculatorForm.querySelectorAll('input[name="second_group_load[]"]');
    secondGroupInputs.forEach((input, index) => {
      const inputGroup = input.closest('.calculator__input-group');
      const isVisible = !inputGroup || !inputGroup.classList.contains('calculator__input-group--hidden');
      
      if (isVisible) {
        const value = parseFloat(normalizeDecimalInput(input.value)) || 0;
        secondGroupLoad.push(value);
      }
    });

    // Собираем third_group_load
    const thirdGroupInputs = calculatorForm.querySelectorAll('input[name="third_group_load[]"]');
    thirdGroupInputs.forEach((input, index) => {
      const inputGroup = input.closest('.calculator__input-group');
      const isVisible = !inputGroup || !inputGroup.classList.contains('calculator__input-group--hidden');
      
      if (isVisible) {
        const value = parseFloat(normalizeDecimalInput(input.value)) || 0;
        thirdGroupLoad.push(value);
      }
    });

    // Собираем cargoes_mass - всегда все 4 значения
    const cargoMassInputs = calculatorForm.querySelectorAll('input[name="cargoes_mass[]"]');
    cargoMassInputs.forEach((input, index) => {
      const value = parseFloat(normalizeDecimalInput(input.value)) || 0;
      cargoessMass.push(value);
    });

    // Собираем основные данные
    const requestData = {
      distance_container_hitch: parseFloat(normalizeDecimalInput(formData.get('distance_container_hitch'))) || 0,
      distance_car_hitch: parseFloat(normalizeDecimalInput(formData.get('distance_car_hitch'))) || 0,
      distance_axle_car: parseFloat(normalizeDecimalInput(formData.get('distance_axle_car'))) || 0,
      distance_axle_container: parseFloat(normalizeDecimalInput(formData.get('distance_axle_container'))) || 0,
      container_length: parseFloat(normalizeDecimalInput(formData.get('container_length'))) || 0,
      first_group_load: parseFloat(normalizeDecimalInput(formData.get('first_group_load'))) || 0,
      second_group_load: secondGroupLoad,
      third_group_load: thirdGroupLoad,
      cargoes_mass: cargoessMass
    };
    
    // Дополнительная валидация
    const errors = [];
    
    if (requestData.distance_container_hitch <= 0) errors.push('Расстояние от контейнера до сцепки');
    if (requestData.distance_car_hitch <= 0) errors.push('Расстояние от осей тягача до сцепки');
    if (requestData.distance_axle_car <= 0) errors.push('Расстояние между осями машины');
    if (requestData.distance_axle_container <= 0) errors.push('Расстояние от осей полуприцепа до осей тягача');
    if (requestData.container_length <= 0) errors.push('Длина полуприцепа');
    if (requestData.first_group_load <= 0) errors.push('Нагрузка на первую ось тягача');
    
    if (secondGroupLoad.length === 0) errors.push('Нагрузки на оси тягача');
    if (thirdGroupLoad.length === 0) errors.push('Нагрузки на оси полуприцепа');

    return requestData;
  }

  async function submitCalculation() {
    if (!validateCurrentStep()) {
      showStepError(currentStep - 1);
      return;
    }

    try {
      const requestData = collectFormData();

      // Валидация данных
      if (!requestData.distance_container_hitch || !requestData.distance_car_hitch || 
          !requestData.distance_axle_car || !requestData.distance_axle_container || 
          !requestData.container_length || !requestData.first_group_load) {
        displayError('Заполните все обязательные поля', resultContainer);
        return;
      }

      if (requestData.second_group_load.length === 0 || requestData.third_group_load.length === 0) {
        displayError('Заполните данные о нагрузках на оси', resultContainer);
        return;
      }

      // Получаем эндпоинт из формы
      const endpoint = calculatorForm.getAttribute('data-end-point');
      const currentDomain = window.location.origin;
      const fullUrl = currentDomain + endpoint;

      // Отправляем запрос на сервер
      const response = await Fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        // Попробуем получить текст ошибки из ответа
        let errorMessage = `Ошибка сервера: ${response.status} ${response.statusText}`;
        try {
          const errorText = await response.text();
          if (errorText) {
            errorMessage += `. Подробности: ${errorText}`;
          }
        } catch (e) {
          // Не удалось получить текст ошибки
        }
        throw new Error(errorMessage);
      }

      // Получаем текст ответа
      const responseText = await response.text();

      if (!responseText || responseText.trim() === '') {
        throw new Error('Сервер вернул пустой ответ. Проверьте правильность данных и попробуйте снова.');
      }

      // Пытаемся парсить JSON
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        throw new Error('Сервер вернул некорректный ответ. Обратитесь к администратору.');
      }

      // Проверяем структуру ответа
      if (!result || typeof result !== 'object') {
        throw new Error('Сервер вернул некорректные данные');
      }

      // Отображаем результат
      displayAxleLoadResult(result);

    } catch (error) {
      // Показываем пользователю понятное сообщение об ошибке
      let userMessage = error.message;
      if (error.message.includes('fetch')) {
        userMessage = 'Ошибка сети. Проверьте подключение к интернету.';
      } else if (error.message.includes('JSON')) {
        userMessage = 'Ошибка обработки данных. Попробуйте еще раз.';
      }
      
      displayError(userMessage, resultContainer);
    }
  }

  function displayAxleLoadResult(data) {
    if (!resultContainer) {
      return;
    }

    const hitchAdditional = data.hitch_additional || 0;
    const firstGroup = data.first_group || 0;
    const secondGroup = data.second_group || [];
    const thirdGroup = data.third_group || [];

    // Подсчитываем массу автопоезда (сумма всех нагрузок)
    const totalMass = firstGroup + 
      secondGroup.reduce((sum, load) => sum + load, 0) + 
      thirdGroup.reduce((sum, load) => sum + load, 0);

    // Подсчитываем массу груза
    const formData = collectFormData();
    const cargoMass = formData.cargoes_mass.reduce((sum, mass) => sum + mass, 0);

    // Показываем блок результатов
    if (resultFormContainer) {
      resultFormContainer.classList.add('calculator__rezult-form--visible');
    }

    imageContainer.classList.add('calculator__form-result-img--hide');
    ctaContainer.classList.add('calculator__cta--visible');

    // Обновляем картинку в результатах
    updateResultImage();

    let resultHTML = `
      <h3 class="calculator__form-result-desc-title">Масса:</h3>
      <div class="calculator__form-result-desc-item-row no-gap">
        <div class="calculator__form-result-desc-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
              <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
              <path d="M46.5869 30.4827H39.7324L40.2275 33.0208H46.2129L46.5869 30.4827ZM27.7637 30.4827H21.9971L22.6162 33.0208H27.2695L27.7637 30.4827ZM12.5322 30.4827H9.50098V33.0208H11.9141L12.5322 30.4827Z" fill="#80B2E7" stroke="#80B2E7"/>
              <path d="M63.6113 30.4827L64.1064 33.0208H66.5V30.4827H63.6113Z" fill="#80B2E7" stroke="#80B2E7"/>
              <path d="M34.8447 28.9658C33.1816 28.9658 31.801 30.3542 31.8008 32.1074C31.8008 33.8609 33.1814 35.25 34.8447 35.25C36.508 35.2499 37.8887 33.8608 37.8887 32.1074C37.8884 30.3542 36.5078 28.9659 34.8447 28.9658Z" stroke="#80B2E7" stroke-width="1.5"/>
              <path d="M59.0342 28.9658C57.371 28.9658 55.9905 30.3542 55.9902 32.1074C55.9902 33.8609 57.3709 35.25 59.0342 35.25C60.6974 35.2499 62.0781 33.8608 62.0781 32.1074C62.0779 30.3542 60.6973 28.9659 59.0342 28.9658Z" stroke="#80B2E7" stroke-width="1.5"/>
              <path d="M17.2803 28.9658C15.6171 28.9658 14.2366 30.3542 14.2363 32.1074C14.2363 33.8609 15.617 35.25 17.2803 35.25C18.9435 35.2499 20.3242 33.8608 20.3242 32.1074C20.324 30.3542 18.9434 28.9659 17.2803 28.9658Z" stroke="#80B2E7" stroke-width="1.5"/>
              <path d="M51.4443 28.9658C49.7812 28.9658 48.4006 30.3542 48.4004 32.1074C48.4004 33.8609 49.781 35.25 51.4443 35.25C53.1076 35.2499 54.4883 33.8608 54.4883 32.1074C54.488 30.3542 53.1074 28.9659 51.4443 28.9658Z" stroke="#80B2E7" stroke-width="1.5"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5566 13C25.1089 13 25.5566 13.4477 25.5566 14V27.922C25.5566 28.4743 25.1089 28.922 24.5566 28.922H21.7727C21.543 28.922 21.3216 28.8435 21.137 28.7069C20.4595 28.2051 18.6863 26.998 17.2786 26.976C15.8119 26.953 13.9427 28.2042 13.2456 28.712C13.0623 28.8456 12.8436 28.922 12.6168 28.922H10.0006C9.44836 28.922 9.00065 28.4743 9.00065 27.922V21.1963C9.00065 21.0416 9.03657 20.8889 9.10559 20.7504L12.6911 13.554C12.8603 13.2146 13.2069 13 13.5862 13H24.5566ZM18.697 15.122C19.2493 15.122 19.697 15.5697 19.697 16.122V20.137C19.697 20.6893 19.2493 21.137 18.697 21.137H13.6275C12.909 21.137 12.425 20.4019 12.7089 19.7419L14.4356 15.7269C14.5934 15.3599 14.9547 15.122 15.3542 15.122H18.697Z" fill="#80B2E7"/>
              <path d="M66 13.5H28.791C28.5149 13.5001 28.291 13.7239 28.291 14V27.6807C28.291 27.9568 28.5149 28.1806 28.791 28.1807H66C66.2761 28.1807 66.5 27.9568 66.5 27.6807V14C66.5 13.7239 66.2761 13.5 66 13.5Z" fill="#80B2E7" stroke="#80B2E7"/>
              <rect x="-0.5" y="0.5" width="3.43641" height="2.2857" rx="0.5" transform="matrix(-1 0 0 1 31.6172 27.238)" stroke="#80B2E7"/>
            </svg>
            <div class="calculator__form-result-txt-container">
                <p class="calculator__form-result-txt">Масса автопоезда:</p>
                <p class="calculator__form-result-txt-accent">${totalMass.toFixed(2)} кг</p>
            </div>
        </div>
        <div class="calculator__form-result-desc-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
              <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
              <path d="M38 20.8494L43.3008 18.6641L30.1758 13.2459L25.6503 15.1134C25.4219 15.2072 25.2075 15.3336 25.0133 15.489L38 20.8494ZM24.0613 17.044C24.0204 17.2356 23.9999 17.4312 24 17.6274V31.4365C23.9999 31.978 24.1571 32.5072 24.4512 32.9556C24.7454 33.4041 25.163 33.7513 25.6503 33.9523L35.725 38.1117C36.1812 38.2995 36.6478 38.4284 37.125 38.4982V22.4351L24.0613 17.044ZM38.875 38.5C39.3548 38.4288 39.8248 38.2991 40.275 38.1135L50.3497 33.9542C50.8372 33.7529 51.2551 33.4055 51.5492 32.9567C51.8434 32.5079 52.0004 31.9784 52 31.4365V17.6274C52 17.4275 51.9796 17.2325 51.9388 17.0422L38.875 22.4351V38.5ZM50.9867 15.4908L45.6562 17.6924L32.5313 12.2742L35.725 10.9522C37.1854 10.3493 38.8146 10.3493 40.275 10.9522L50.3497 15.1116C50.5781 15.2054 50.7925 15.3318 50.9867 15.4872" fill="#80B2E7"/>
            </svg>
            <div class="calculator__form-result-txt-container">
                <p class="calculator__form-result-txt">Масса груза:</p>
                <p class="calculator__form-result-txt-accent">${cargoMass.toFixed(2)} кг</p>
            </div>
        </div>
      </div>

      <div class="calculator__form-result-desc-item-row no-gap">
        <div class="calculator__form-result-desc-item-row-block">
          <h3 class="calculator__form-result-desc-title">Нагрузка на оси тягача:</h3>
          <div class="calculator__form-result-desc-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
              <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47-8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
              <path d="M58.0762 29.8513L58.7451 33.1785H62.002V29.8513H58.0762ZM35.0938 29.8513H28.7217L29.5576 33.1785H34.4248L35.0938 29.8513ZM17.1133 29.8513H13V33.1785H16.2773L17.1133 29.8513Z" fill="#80B2E7" stroke="#80B2E7"/>
              <path d="M52.0664 28.187C49.9729 28.1873 48.2842 29.875 48.2842 31.9468C48.2842 34.0185 49.9729 35.7063 52.0664 35.7065C54.1601 35.7065 55.8496 34.0187 55.8496 31.9468C55.8496 29.8749 54.1601 28.187 52.0664 28.187Z" stroke="#80B2E7" stroke-width="2"/>
              <path d="M41.4375 28.187C39.344 28.1873 37.6553 29.875 37.6553 31.9468C37.6553 34.0185 39.344 35.7063 41.4375 35.7065C43.5312 35.7065 45.2207 34.0187 45.2207 31.9468C45.2207 29.8749 43.5312 28.187 41.4375 28.187Z" stroke="#80B2E7" stroke-width="2"/>
              <path d="M22.9395 28.187C20.846 28.1873 19.1572 29.875 19.1572 31.9468C19.1572 34.0185 20.846 35.7063 22.9395 35.7065C25.0332 35.7065 26.7226 34.0187 26.7227 31.9468C26.7227 29.8749 25.0332 28.187 22.9395 28.187Z" stroke="#80B2E7" stroke-width="2"/>
              <mask id="path-6-inside-1_6334_77207" fill="white">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3711 8.57959C32.9234 8.57959 33.3711 9.0273 33.3711 9.57959V27.0513C33.3711 27.6036 32.9234 28.0513 32.3711 28.0513H28.5003C28.2757 28.0513 28.0585 27.9761 27.8769 27.8439C27.0882 27.2697 24.7668 25.6992 22.936 25.6714C21.0299 25.6425 18.5847 27.2695 17.775 27.8493C17.5947 27.9784 17.3807 28.0513 17.1589 28.0513H13.5009C12.9486 28.0513 12.5009 27.6036 12.5009 27.0513V18.5572C12.5009 18.3983 12.5388 18.2417 12.6114 18.1004L17.2221 9.12274C17.3934 8.78926 17.7368 8.57959 18.1116 8.57959H32.3711ZM24.9805 11.1768C25.5328 11.1768 25.9805 11.6245 25.9805 12.1768V17.5327C25.9805 18.085 25.5328 18.5327 24.9805 18.5327H17.9521C17.2289 18.5327 16.7448 17.7886 17.0379 17.1275L19.4123 11.7715C19.5726 11.4099 19.9309 11.1768 20.3265 11.1768H24.9805Z"/>
              </mask>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3711 8.57959C32.9234 8.57959 33.3711 9.0273 33.3711 9.57959V27.0513C33.3711 27.6036 32.9234 28.0513 32.3711 28.0513H28.5003C28.2757 28.0513 28.0585 27.9761 27.8769 27.8439C27.0882 27.2697 24.7668 25.6992 22.936 25.6714C21.0299 25.6425 18.5847 27.2695 17.775 27.8493C17.5947 27.9784 17.3807 28.0513 17.1589 28.0513H13.5009C12.9486 28.0513 12.5009 27.6036 12.5009 27.0513V18.5572C12.5009 18.3983 12.5388 18.2417 12.6114 18.1004L17.2221 9.12274C17.3934 8.78926 17.7368 8.57959 18.1116 8.57959H32.3711ZM24.9805 11.1768C25.5328 11.1768 25.9805 11.6245 25.9805 12.1768V17.5327C25.9805 18.085 25.5328 18.5327 24.9805 18.5327H17.9521C17.2289 18.5327 16.7448 17.7886 17.0379 17.1275L19.4123 11.7715C19.5726 11.4099 19.9309 11.1768 20.3265 11.1768H24.9805Z" fill="#80B2E7"/>
              <path d="M27.8769 27.8439L27.2884 28.6524L27.2884 28.6524L27.8769 27.8439ZM22.936 25.6714L22.9208 26.6713H22.9208L22.936 25.6714ZM17.775 27.8493L17.1928 27.0363L17.1928 27.0363L17.775 27.8493ZM12.6114 18.1004L13.5009 18.5572L13.5009 18.5572L12.6114 18.1004ZM17.2221 9.12274L18.1116 9.57959V9.57959L17.2221 9.12274ZM17.0379 17.1275L16.1237 16.7222V16.7222L17.0379 17.1275ZM19.4123 11.7715L18.4981 11.3662V11.3662L19.4123 11.7715ZM33.3711 9.57959H32.3711L32.3711 9.57959V8.57959V7.57959C33.4757 7.57959 34.3711 8.47502 34.3711 9.57959H33.3711ZM33.3711 27.0513H32.3711V9.57959H33.3711H34.3711V27.0513H33.3711ZM32.3711 28.0513V27.0513H32.3711H33.3711H34.3711C34.3711 28.1558 33.4757 29.0513 32.3711 29.0513V28.0513ZM28.5003 28.0513V27.0513H32.3711V28.0513V29.0513H28.5003V28.0513ZM27.8769 27.8439L28.4655 27.0354C28.476 27.0431 28.485 27.0472 28.4911 27.0493C28.497 27.0513 28.5 27.0513 28.5003 27.0513V28.0513V29.0513C28.0508 29.0513 27.6298 28.9009 27.2884 28.6524L27.8769 27.8439ZM22.936 25.6714L22.9512 24.6715C24.104 24.689 25.3112 25.1773 26.2553 25.6639C27.226 26.1641 28.0494 26.7325 28.4655 27.0354L27.8769 27.8439L27.2884 28.6524C26.9157 28.3811 26.184 27.8771 25.3391 27.4416C24.4676 26.9925 23.5987 26.6816 22.9208 26.6713L22.936 25.6714ZM17.775 27.8493L17.1928 27.0363C17.6198 26.7304 18.481 26.1459 19.497 25.6377C20.4847 25.1436 21.7504 24.6533 22.9512 24.6715L22.936 25.6714L22.9208 26.6713C22.2155 26.6606 21.3056 26.9693 20.3918 27.4264C19.5062 27.8694 18.7399 28.3883 18.3572 28.6624L17.775 27.8493ZM17.1589 28.0513V27.0513C17.1595 27.0513 17.1719 27.0513 17.1928 27.0363L17.775 27.8493L18.3572 28.6624C18.0175 28.9056 17.6019 29.0513 17.1589 29.0513V28.0513ZM13.5009 28.0513V27.0513H17.1589V28.0513V29.0513H13.5009V28.0513ZM12.5009 27.0513H13.5009V28.0513V29.0513C12.3963 29.0513 11.5009 28.1558 11.5009 27.0513H12.5009ZM12.5009 18.5572H13.5009V27.0513H12.5009H11.5009V18.5572H12.5009ZM12.6114 18.1004L13.5009 18.5572L13.5009 18.5572H12.5009H11.5009C11.5009 18.2394 11.5766 17.9262 11.7218 17.6435L12.6114 18.1004ZM17.2221 9.12274L18.1116 9.57959L13.5009 18.5572L12.6114 18.1004L11.7218 17.6435L16.3326 8.66588L17.2221 9.12274ZM18.1116 8.57959V9.57959L18.1116 9.57959L17.2221 9.12274L16.3326 8.66589C16.6751 7.99894 17.3619 7.57959 18.1116 7.57959V8.57959ZM32.3711 8.57959V9.57959H18.1116V8.57959V7.57959H32.3711V8.57959ZM25.9805 12.1768H24.9805V12.1768V11.1768V10.1768C26.085 10.1768 26.9805 11.0722 26.9805 12.1768H25.9805ZM25.9805 17.5327H24.9805V12.1768H25.9805H26.9805V17.5327H25.9805ZM24.9805 18.5327V17.5327H24.9805H25.9805H26.9805C26.9805 18.6373 26.085 19.5327 24.9805 19.5327V18.5327ZM17.9521 18.5327V17.5327H24.9805V18.5327V19.5327H17.9521V18.5327ZM17.0379 17.1275L17.9521 17.5327L17.9521 17.5327V18.5327V19.5327C16.5056 19.5327 15.5375 18.0446 16.1237 16.7222L17.0379 17.1275ZM19.4123 11.7715L20.3265 12.1768L17.9521 17.5327L17.0379 17.1275L16.1237 16.7222L18.4981 11.3662L19.4123 11.7715ZM20.3265 11.1768V12.1768L20.3265 12.1768L19.4123 11.7715L18.4981 11.3662C18.8187 10.643 19.5354 10.1768 20.3265 10.1768V11.1768ZM24.9805 11.1768V12.1768H20.3265V11.1768V10.1768H24.9805V11.1768Z" fill="#80B2E7" mask="url(#path-6-inside-1_6334_77207)"/>
              <path d="M22.9355 32.4204L22.9355 40.4204M22.9355 40.4204L30.4355 40.4204M22.9355 40.4204L15.4355 40.4204" stroke="#0065CE" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <div class="calculator__form-result-txt-container">
                <p class="calculator__form-result-txt">Нагрузка на ось тягача 1:</p>
                <p class="calculator__form-result-txt-accent">${firstGroup.toFixed(2)} кг</p>
            </div>
          </div>`;

    // Добавляем нагрузки на 2 и 3 оси тягача
    if (secondGroup && secondGroup.length > 0) {
      secondGroup.forEach((load, index) => {
        const tractorAxisNumber = index + 2;
        let tractorSvg = '';
        
        if (tractorAxisNumber === 2) {
          tractorSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
                        <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
                        <path d="M58.0762 29.8513L58.7451 33.1785H62.002V29.8513H58.0762ZM35.0938 29.8513H28.7217L29.5576 33.1785H34.4248L35.0938 29.8513ZM17.1133 29.8513H13V33.1785H16.2773L17.1133 29.8513Z" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M52.0664 28.187C49.9729 28.1873 48.2842 29.875 48.2842 31.9468C48.2842 34.0185 49.9729 35.7063 52.0664 35.7065C54.1601 35.7065 55.8496 34.0187 55.8496 31.9468C55.8496 29.8749 54.1601 28.187 52.0664 28.187Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M41.4375 28.187C39.344 28.1873 37.6553 29.875 37.6553 31.9468C37.6553 34.0185 39.344 35.7063 41.4375 35.7065C43.5312 35.7065 45.2207 34.0187 45.2207 31.9468C45.2207 29.8749 43.5312 28.187 41.4375 28.187Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M22.9395 28.187C20.846 28.1873 19.1572 29.875 19.1572 31.9468C19.1572 34.0185 20.846 35.7063 22.9395 35.7065C25.0332 35.7065 26.7226 34.0187 26.7227 31.9468C26.7227 29.8749 25.0332 28.187 22.9395 28.187Z" stroke="#80B2E7" stroke-width="2"/>
                        <mask id="path-6-inside-1_6334_77216" fill="white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3711 8.57959C32.9234 8.57959 33.3711 9.0273 33.3711 9.57959V27.0513C33.3711 27.6036 32.9234 28.0513 32.3711 28.0513H28.5003C28.2757 28.0513 28.0585 27.9761 27.8769 27.8439C27.0882 27.2697 24.7668 25.6992 22.936 25.6714C21.0299 25.6425 18.5847 27.2695 17.775 27.8493C17.5947 27.9784 17.3807 28.0513 17.1589 28.0513H13.5009C12.9486 28.0513 12.5009 27.6036 12.5009 27.0513V18.5572C12.5009 18.3983 12.5388 18.2417 12.6114 18.1004L17.2221 9.12274C17.3934 8.78926 17.7368 8.57959 18.1116 8.57959H32.3711ZM24.9805 11.1768C25.5328 11.1768 25.9805 11.6245 25.9805 12.1768V17.5327C25.9805 18.085 25.5328 18.5327 24.9805 18.5327H17.9521C17.2289 18.5327 16.7448 17.7886 17.0379 17.1275L19.4123 11.7715C19.5726 11.4099 19.9309 11.1768 20.3265 11.1768H24.9805Z"/>
                        </mask>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3711 8.57959C32.9234 8.57959 33.3711 9.0273 33.3711 9.57959V27.0513C33.3711 27.6036 32.9234 28.0513 32.3711 28.0513H28.5003C28.2757 28.0513 28.0585 27.9761 27.8769 27.8439C27.0882 27.2697 24.7668 25.6992 22.936 25.6714C21.0299 25.6425 18.5847 27.2695 17.775 27.8493C17.5947 27.9784 17.3807 28.0513 17.1589 28.0513H13.5009C12.9486 28.0513 12.5009 27.6036 12.5009 27.0513V18.5572C12.5009 18.3983 12.5388 18.2417 12.6114 18.1004L17.2221 9.12274C17.3934 8.78926 17.7368 8.57959 18.1116 8.57959H32.3711ZM24.9805 11.1768C25.5328 11.1768 25.9805 11.6245 25.9805 12.1768V17.5327C25.9805 18.085 25.5328 18.5327 24.9805 18.5327H17.9521C17.2289 18.5327 16.7448 17.7886 17.0379 17.1275L19.4123 11.7715C19.5726 11.4099 19.9309 11.1768 20.3265 11.1768H24.9805Z" fill="#80B2E7"/>
                        <path d="M27.8769 27.8439L27.2884 28.6524L27.2884 28.6524L27.8769 27.8439ZM22.936 25.6714L22.9208 26.6713H22.9208L22.936 25.6714ZM17.775 27.8493L17.1928 27.0363L17.1928 27.0363L17.775 27.8493ZM12.6114 18.1004L13.5009 18.5572L13.5009 18.5572L12.6114 18.1004ZM17.2221 9.12274L18.1116 9.57959V9.57959L17.2221 9.12274ZM17.0379 17.1275L16.1237 16.7222V16.7222L17.0379 17.1275ZM19.4123 11.7715L18.4981 11.3662V11.3662L19.4123 11.7715ZM33.3711 9.57959H32.3711L32.3711 9.57959V8.57959V7.57959C33.4757 7.57959 34.3711 8.47502 34.3711 9.57959H33.3711ZM33.3711 27.0513H32.3711V9.57959H33.3711H34.3711V27.0513H33.3711ZM32.3711 28.0513V27.0513H32.3711H33.3711H34.3711C34.3711 28.1558 33.4757 29.0513 32.3711 29.0513V28.0513ZM28.5003 28.0513V27.0513H32.3711V28.0513V29.0513H28.5003V28.0513ZM27.8769 27.8439L28.4655 27.0354C28.476 27.0431 28.485 27.0472 28.4911 27.0493C28.497 27.0513 28.5 27.0513 28.5003 27.0513V28.0513V29.0513C28.0508 29.0513 27.6298 28.9009 27.2884 28.6524L27.8769 27.8439ZM22.936 25.6714L22.9512 24.6715C24.104 24.689 25.3112 25.1773 26.2553 25.6639C27.226 26.1641 28.0494 26.7325 28.4655 27.0354L27.8769 27.8439L27.2884 28.6524C26.9157 28.3811 26.184 27.8771 25.3391 27.4416C24.4676 26.9925 23.5987 26.6816 22.9208 26.6713L22.936 25.6714ZM17.775 27.8493L17.1928 27.0363C17.6198 26.7304 18.481 26.1459 19.497 25.6377C20.4847 25.1436 21.7504 24.6533 22.9512 24.6715L22.936 25.6714L22.9208 26.6713C22.2155 26.6606 21.3056 26.9693 20.3918 27.4264C19.5062 27.8694 18.7399 28.3883 18.3572 28.6624L17.775 27.8493ZM17.1589 28.0513V27.0513C17.1595 27.0513 17.1719 27.0513 17.1928 27.0363L17.775 27.8493L18.3572 28.6624C18.0175 28.9056 17.6019 29.0513 17.1589 29.0513V28.0513ZM13.5009 28.0513V27.0513H17.1589V28.0513V29.0513H13.5009V28.0513ZM12.5009 27.0513H13.5009V28.0513V29.0513C12.3963 29.0513 11.5009 28.1558 11.5009 27.0513H12.5009ZM12.5009 18.5572H13.5009V27.0513H12.5009H11.5009V18.5572H12.5009ZM12.6114 18.1004L13.5009 18.5572L13.5009 18.5572H12.5009H11.5009C11.5009 18.2394 11.5766 17.9262 11.7218 17.6435L12.6114 18.1004ZM17.2221 9.12274L18.1116 9.57959L13.5009 18.5572L12.6114 18.1004L11.7218 17.6435L16.3326 8.66588L17.2221 9.12274ZM18.1116 8.57959V9.57959L18.1116 9.57959L17.2221 9.12274L16.3326 8.66589C16.6751 7.99894 17.3619 7.57959 18.1116 7.57959V8.57959ZM32.3711 8.57959V9.57959H18.1116V8.57959V7.57959H32.3711V8.57959ZM25.9805 12.1768H24.9805V12.1768V11.1768V10.1768C26.085 10.1768 26.9805 11.0722 26.9805 12.1768H25.9805ZM25.9805 17.5327H24.9805V12.1768H25.9805H26.9805V17.5327H25.9805ZM24.9805 18.5327V17.5327H24.9805H25.9805H26.9805C26.9805 18.6373 26.085 19.5327 24.9805 19.5327V18.5327ZM17.9521 18.5327V17.5327H24.9805V18.5327V19.5327H17.9521V18.5327ZM17.0379 17.1275L17.9521 17.5327L17.9521 17.5327V18.5327V19.5327C16.5056 19.5327 15.5375 18.0446 16.1237 16.7222L17.0379 17.1275ZM19.4123 11.7715L20.3265 12.1768L17.9521 17.5327L17.0379 17.1275L16.1237 16.7222L18.4981 11.3662L19.4123 11.7715ZM20.3265 11.1768V12.1768L20.3265 12.1768L19.4123 11.7715L18.4981 11.3662C18.8187 10.643 19.5354 10.1768 20.3265 10.1768V11.1768ZM24.9805 11.1768V12.1768H20.3265V11.1768V10.1768H24.9805V11.1768Z" fill="#80B2E7" mask="url(#path-6-inside-1_6334_77216)"/>
                        <path d="M41.4375 32.4204L41.4375 40.4204M41.4375 40.4204L48.9375 40.4204M41.4375 40.4204L33.9375 40.4204" stroke="#0065CE" stroke-width="2" stroke-linecap="round"/>
                      </svg>`;
        } else if (tractorAxisNumber === 3) {
          tractorSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
                        <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
                        <path d="M58.0762 29.8513L58.7451 33.1785H62.002V29.8513H58.0762ZM35.0938 29.8513H28.7217L29.5576 33.1785H34.4248L35.0938 29.8513ZM17.1133 29.8513H13V33.1785H16.2773L17.1133 29.8513Z" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M52.0664 28.187C49.9729 28.1873 48.2842 29.875 48.2842 31.9468C48.2842 34.0185 49.9729 35.7063 52.0664 35.7065C54.1601 35.7065 55.8496 34.0187 55.8496 31.9468C55.8496 29.8749 54.1601 28.187 52.0664 28.187Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M41.4375 28.187C39.344 28.1873 37.6553 29.875 37.6553 31.9468C37.6553 34.0185 39.344 35.7063 41.4375 35.7065C43.5312 35.7065 45.2207 34.0187 45.2207 31.9468C45.2207 29.8749 43.5312 28.187 41.4375 28.187Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M22.9395 28.187C20.846 28.1873 19.1572 29.875 19.1572 31.9468C19.1572 34.0185 20.846 35.7063 22.9395 35.7065C25.0332 35.7065 26.7226 34.0187 26.7227 31.9468C26.7227 29.8749 25.0332 28.187 22.9395 28.187Z" stroke="#80B2E7" stroke-width="2"/>
                        <mask id="path-6-inside-1_6345_167276" fill="white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3711 8.57959C32.9234 8.57959 33.3711 9.0273 33.3711 9.57959V27.0513C33.3711 27.6036 32.9234 28.0513 32.3711 28.0513H28.5003C28.2757 28.0513 28.0585 27.9761 27.8769 27.8439C27.0882 27.2697 24.7668 25.6992 22.936 25.6714C21.0299 25.6425 18.5847 27.2695 17.775 27.8493C17.5947 27.9784 17.3807 28.0513 17.1589 28.0513H13.5009C12.9486 28.0513 12.5009 27.6036 12.5009 27.0513V18.5572C12.5009 18.3983 12.5388 18.2417 12.6114 18.1004L17.2221 9.12274C17.3934 8.78926 17.7368 8.57959 18.1116 8.57959H32.3711ZM24.9805 11.1768C25.5328 11.1768 25.9805 11.6245 25.9805 12.1768V17.5327C25.9805 18.085 25.5328 18.5327 24.9805 18.5327H17.9521C17.2289 18.5327 16.7448 17.7886 17.0379 17.1275L19.4123 11.7715C19.5726 11.4099 19.9309 11.1768 20.3265 11.1768H24.9805Z"/>
                        </mask>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3711 8.57959C32.9234 8.57959 33.3711 9.0273 33.3711 9.57959V27.0513C33.3711 27.6036 32.9234 28.0513 32.3711 28.0513H28.5003C28.2757 28.0513 28.0585 27.9761 27.8769 27.8439C27.0882 27.2697 24.7668 25.6992 22.936 25.6714C21.0299 25.6425 18.5847 27.2695 17.775 27.8493C17.5947 27.9784 17.3807 28.0513 17.1589 28.0513H13.5009C12.9486 28.0513 12.5009 27.6036 12.5009 27.0513V18.5572C12.5009 18.3983 12.5388 18.2417 12.6114 18.1004L17.2221 9.12274C17.3934 8.78926 17.7368 8.57959 18.1116 8.57959H32.3711ZM24.9805 11.1768C25.5328 11.1768 25.9805 11.6245 25.9805 12.1768V17.5327C25.9805 18.085 25.5328 18.5327 24.9805 18.5327H17.9521C17.2289 18.5327 16.7448 17.7886 17.0379 17.1275L19.4123 11.7715C19.5726 11.4099 19.9309 11.1768 20.3265 11.1768H24.9805Z" fill="#80B2E7"/>
                        <path d="M27.8769 27.8439L27.2884 28.6524L27.2884 28.6524L27.8769 27.8439ZM22.936 25.6714L22.9208 26.6713H22.9208L22.936 25.6714ZM17.775 27.8493L17.1928 27.0363L17.1928 27.0363L17.775 27.8493ZM12.6114 18.1004L13.5009 18.5572L13.5009 18.5572L12.6114 18.1004ZM17.2221 9.12274L18.1116 9.57959V9.57959L17.2221 9.12274ZM17.0379 17.1275L16.1237 16.7222V16.7222L17.0379 17.1275ZM19.4123 11.7715L18.4981 11.3662V11.3662L19.4123 11.7715ZM33.3711 9.57959H32.3711L32.3711 9.57959V8.57959V7.57959C33.4757 7.57959 34.3711 8.47502 34.3711 9.57959H33.3711ZM33.3711 27.0513H32.3711V9.57959H33.3711H34.3711V27.0513H33.3711ZM32.3711 28.0513V27.0513H32.3711H33.3711H34.3711C34.3711 28.1558 33.4757 29.0513 32.3711 29.0513V28.0513ZM28.5003 28.0513V27.0513H32.3711V28.0513V29.0513H28.5003V28.0513ZM27.8769 27.8439L28.4655 27.0354C28.476 27.0431 28.485 27.0472 28.4911 27.0493C28.497 27.0513 28.5 27.0513 28.5003 27.0513V28.0513V29.0513C28.0508 29.0513 27.6298 28.9009 27.2884 28.6524L27.8769 27.8439ZM22.936 25.6714L22.9512 24.6715C24.104 24.689 25.3112 25.1773 26.2553 25.6639C27.226 26.1641 28.0494 26.7325 28.4655 27.0354L27.8769 27.8439L27.2884 28.6524C26.9157 28.3811 26.184 27.8771 25.3391 27.4416C24.4676 26.9925 23.5987 26.6816 22.9208 26.6713L22.936 25.6714ZM17.775 27.8493L17.1928 27.0363C17.6198 26.7304 18.481 26.1459 19.497 25.6377C20.4847 25.1436 21.7504 24.6533 22.9512 24.6715L22.936 25.6714L22.9208 26.6713C22.2155 26.6606 21.3056 26.9693 20.3918 27.4264C19.5062 27.8694 18.7399 28.3883 18.3572 28.6624L17.775 27.8493ZM17.1589 28.0513V27.0513C17.1595 27.0513 17.1719 27.0513 17.1928 27.0363L17.775 27.8493L18.3572 28.6624C18.0175 28.9056 17.6019 29.0513 17.1589 29.0513V28.0513ZM13.5009 28.0513V27.0513H17.1589V28.0513V29.0513H13.5009V28.0513ZM12.5009 27.0513H13.5009V28.0513V29.0513C12.3963 29.0513 11.5009 28.1558 11.5009 27.0513H12.5009ZM12.5009 18.5572H13.5009V27.0513H12.5009H11.5009V18.5572H12.5009ZM12.6114 18.1004L13.5009 18.5572L13.5009 18.5572H12.5009H11.5009C11.5009 18.2394 11.5766 17.9262 11.7218 17.6435L12.6114 18.1004ZM17.2221 9.12274L18.1116 9.57959L13.5009 18.5572L12.6114 18.1004L11.7218 17.6435L16.3326 8.66588L17.2221 9.12274ZM18.1116 8.57959V9.57959L18.1116 9.57959L17.2221 9.12274L16.3326 8.66589C16.6751 7.99894 17.3619 7.57959 18.1116 7.57959V8.57959ZM32.3711 8.57959V9.57959H18.1116V8.57959V7.57959H32.3711V8.57959ZM25.9805 12.1768H24.9805V12.1768V11.1768V10.1768C26.085 10.1768 26.9805 11.0722 26.9805 12.1768H25.9805ZM25.9805 17.5327H24.9805V12.1768H25.9805H26.9805V17.5327H25.9805ZM24.9805 18.5327V17.5327H24.9805H25.9805H26.9805C26.9805 18.6373 26.085 19.5327 24.9805 19.5327V18.5327ZM17.9521 18.5327V17.5327H24.9805V18.5327V19.5327H17.9521V18.5327ZM17.0379 17.1275L17.9521 17.5327L17.9521 17.5327V18.5327V19.5327C16.5056 19.5327 15.5375 18.0446 16.1237 16.7222L17.0379 17.1275ZM19.4123 11.7715L20.3265 12.1768L17.9521 17.5327L17.0379 17.1275L16.1237 16.7222L18.4981 11.3662L19.4123 11.7715ZM20.3265 11.1768V12.1768L20.3265 12.1768L19.4123 11.7715L18.4981 11.3662C18.8187 10.643 19.5354 10.1768 20.3265 10.1768V11.1768ZM24.9805 11.1768V12.1768H20.3265V11.1768V10.1768H24.9805V11.1768Z" fill="#80B2E7" mask="url(#path-6-inside-1_6345_167276)"/>
                        <path d="M52.0664 32.4204L52.0664 40.4204M52.0664 40.4204L59.5664 40.4204M52.0664 40.4204L44.5664 40.4204" stroke="#0065CE" stroke-width="2" stroke-linecap="round"/>
                      </svg>`;
        }
        
        resultHTML += `
          <div class="calculator__form-result-desc-item">
              ${tractorSvg}
              <div class="calculator__form-result-txt-container">
                  <p class="calculator__form-result-txt">Нагрузка на ось тягача ${tractorAxisNumber}:</p>
                  <p class="calculator__form-result-txt-accent">${(load || 0).toFixed(2)} кг</p>
              </div>
          </div>`;
      });
    }

    resultHTML += `
        </div>

        <div class="calculator__form-result-desc-item-row-block">
          <h3 class="calculator__form-result-desc-title">Нагрузка на оси полуприцепа:</h3>`;

    // Добавляем нагрузки на оси полуприцепа (1, 2, 3 оси)
    if (thirdGroup && thirdGroup.length > 0) {
      thirdGroup.forEach((load, index) => {
        const trailerAxisNumber = index + 1;
        let trailerSvg = '';
        
        if (trailerAxisNumber === 1) {
          trailerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
                        <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
                        <path d="M35.6162 28.1699C33.7616 28.1699 32.2705 29.6604 32.2705 31.4824C32.2708 33.3042 33.7618 34.7939 35.6162 34.7939C37.4705 34.7938 38.9607 33.3041 38.9609 31.4824C38.9609 29.6605 37.4707 28.1701 35.6162 28.1699Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M60.5742 29.5603L61.1631 32.4802H64.0391V29.5603H60.5742Z" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M55.4131 28.1028C53.5585 28.1028 52.0674 29.5933 52.0674 31.4153C52.0676 33.2371 53.5586 34.7268 55.4131 34.7268C57.2674 34.7266 58.7576 33.237 58.7578 31.4153C58.7578 29.5934 57.2676 28.1029 55.4131 28.1028Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M45.3037 28.1699C43.4491 28.1699 41.958 29.6604 41.958 31.4824C41.9583 33.3042 43.4493 34.7939 45.3037 34.7939C47.158 34.7938 48.6482 33.3041 48.6484 31.4824C48.6484 29.6605 47.1582 28.1701 45.3037 28.1699Z" stroke="#80B2E7" stroke-width="2"/>
                        <rect x="-0.5" y="0.5" width="52.7935" height="16.3728" rx="0.5" transform="matrix(-1 0 0 1 63.5391 10.2451)" fill="#80B2E7" stroke="#80B2E7"/>
                        <rect x="-0.5" y="0.5" width="6.17247" height="2.47457" rx="0.5" transform="matrix(-1 0 0 1 16.918 26.4585)" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M35.5922 32.3047L35.5922 40.5001M35.5922 40.5001L43.2754 40.5001M35.5922 40.5001L27.9091 40.5001" stroke="#0065CE" stroke-width="2" stroke-linecap="round"/>
                      </svg>`;
        } else if (trailerAxisNumber === 2) {
          trailerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
                        <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
                        <path d="M35.9736 28.1699C34.119 28.1699 32.6279 29.6604 32.6279 31.4824C32.6282 33.3042 34.1192 34.7939 35.9736 34.7939C37.8279 34.7938 39.3181 33.3041 39.3184 31.4824C39.3184 29.6605 37.8281 28.1701 35.9736 28.1699Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M60.9316 29.5603L61.5205 32.4802H64.3965V29.5603H60.9316Z" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M55.7705 28.1028C53.9159 28.1028 52.4248 29.5933 52.4248 31.4153C52.4251 33.2371 53.9161 34.7268 55.7705 34.7268C57.6248 34.7266 59.115 33.237 59.1152 31.4153C59.1152 29.5934 57.625 28.1029 55.7705 28.1028Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M45.6611 28.1699C43.8065 28.1699 42.3154 29.6604 42.3154 31.4824C42.3157 33.3042 43.8067 34.7939 45.6611 34.7939C47.5154 34.7938 49.0056 33.3041 49.0059 31.4824C49.0059 29.6605 47.5156 28.1701 45.6611 28.1699Z" stroke="#80B2E7" stroke-width="2"/>
                        <rect x="-0.5" y="0.5" width="52.7935" height="16.3728" rx="0.5" transform="matrix(-1 0 0 1 63.8965 10.2451)" fill="#80B2E7" stroke="#80B2E7"/>
                        <rect x="-0.5" y="0.5" width="6.17247" height="2.47457" rx="0.5" transform="matrix(-1 0 0 1 17.2754 26.4585)" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M45.6606 32.3047L45.6606 40.5001M45.6606 40.5001L53.3437 40.5001M45.6606 40.5001L37.9774 40.5001" stroke="#0065CE" stroke-width="2" stroke-linecap="round"/>
                      </svg>`;
        } else if (trailerAxisNumber === 3) {
          trailerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
                        <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
                        <path d="M35.9736 28.1699C34.119 28.1699 32.6279 29.6604 32.6279 31.4824C32.6282 33.3042 34.1192 34.7939 35.9736 34.7939C37.8279 34.7938 39.3181 33.3041 39.3184 31.4824C39.3184 29.6605 37.8281 28.1701 35.9736 28.1699Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M60.9316 29.5605L61.5205 32.4805H64.3965V29.5605H60.9316Z" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M55.7705 28.1025C53.9159 28.1025 52.4248 29.593 52.4248 31.415C52.4251 33.2368 53.9161 34.7266 55.7705 34.7266C57.6248 34.7264 59.115 33.2367 59.1152 31.415C59.1152 29.5931 57.625 28.1027 55.7705 28.1025Z" stroke="#80B2E7" stroke-width="2"/>
                        <path d="M45.6611 28.1699C43.8065 28.1699 42.3154 29.6604 42.3154 31.4824C42.3157 33.3042 43.8067 34.7939 45.6611 34.7939C47.5154 34.7938 49.0056 33.3041 49.0059 31.4824C49.0059 29.6605 47.5156 28.1701 45.6611 28.1699Z" stroke="#80B2E7" stroke-width="2"/>
                        <rect x="-0.5" y="0.5" width="52.7935" height="16.3728" rx="0.5" transform="matrix(-1 0 0 1 63.8965 10.2451)" fill="#80B2E7" stroke="#80B2E7"/>
                        <rect x="-0.5" y="0.5" width="6.17247" height="2.47457" rx="0.5" transform="matrix(-1 0 0 1 17.2754 26.4585)" fill="#80B2E7" stroke="#80B2E7"/>
                        <path d="M55.77 32.3047L55.77 40.5001M55.77 40.5001L63.4531 40.5001M55.77 40.5001L48.0868 40.5001" stroke="#0065CE" stroke-width="2" stroke-linecap="round"/>
                      </svg>`;
        }
        
        resultHTML += `
          <div class="calculator__form-result-desc-item">
              ${trailerSvg}
              <div class="calculator__form-result-txt-container">
                  <p class="calculator__form-result-txt">Нагрузка на ось полуприцепа ${trailerAxisNumber}:</p>
                  <p class="calculator__form-result-txt-accent">${(load || 0).toFixed(2)} кг</p>
              </div>
          </div>`;
      });
    }

    resultHTML += `
        </div>
      </div>`;

    resultContainer.innerHTML = resultHTML;
  }
};